import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CalculatorSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CalculatorSVG;
